import { CENTER_DEFAULT } from './schemaDefaults/center';
import { FULL_WIDTH_DEFAULT } from './schemaDefaults/fullWidth';
import { MONOGRAM_DEFAULT } from './schemaDefaults/monogram';
import { NO_PHOTO_DEFAULT } from './schemaDefaults/noPhoto';
import { PAGE_WIDTH_DEFAULT } from './schemaDefaults/pageWidth';
import { PHOTO_ARCH_DEFAULT } from './schemaDefaults/photoArch';
import { PHOTO_DUO_LEFT_DEFAULT } from './schemaDefaults/photoDuoLeft';
import { PHOTO_DUO_RIGHT_DEFAULT } from './schemaDefaults/photoDuoRight';
import { PHOTO_MARQUEE_DEFAULT } from './schemaDefaults/photoMarquee';
import { PHOTO_BACKGROUND_DEFAULT } from './schemaDefaults/photoBackground';
import { PHOTO_BACKGROUND_MONOGRAM_DEFAULT } from './schemaDefaults/photoBackgroundMonogram';
import { VIDEO_BACKGROUND_DEFAULT } from './schemaDefaults/videoBackground';
import { VIDEO_BACKGROUND_MONOGRAM_DEFAULT } from './schemaDefaults/videoBackgroundMonogram';
import { VIDEO_ARCH_DEFAULT } from './schemaDefaults/videoArch';
import { PHOTO_SLIDER_DEFAULT } from './schemaDefaults/photoSlider';
import { PHOTO_TRIO_DEFAULT } from './schemaDefaults/photoTrio';
import { PHOTO_TRIO_PAGE_WIDTH_DEFAULT } from './schemaDefaults/photoTrioPageWidth';

export const DEFAULT_HEADER_PRESENTATION_LAYOUT_BY_WEBSITE_LAYOUT: Record<string, string> = {
  aloha: 'center',
  brannan: 'noPhoto',
};

export const PHOTO_PRESENTATION_LAYOUT_SCHEMA_URL_BY_WEBSITE_LAYOUT = {
  aloha: {
    center: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/center-v1_1_1.json',
      template: CENTER_DEFAULT,
    },
    photoSlider: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoSlider-v1_1_1.json',
      template: PHOTO_SLIDER_DEFAULT,
    },
  },
  brannan: {
    monogram: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/monogram-v1_1_1.json',
      template: MONOGRAM_DEFAULT,
    },
    center: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/center-v1_1_1.json',
      template: CENTER_DEFAULT,
    },
    fullWidth: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/fullWidth-v1_1_1.json',
      template: FULL_WIDTH_DEFAULT,
    },
    pageWidth: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/pageWidth-v1_1_1.json',
      template: PAGE_WIDTH_DEFAULT,
    },
    photoSlider: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoSlider-v1_1_1.json',
      template: PHOTO_SLIDER_DEFAULT,
    },
    photoTrio: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoTrio-v1_1_1.json',
      template: PHOTO_TRIO_DEFAULT,
    },
    photoTrioPageWidth: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoTrioPageWidth-v1_1_1.json',
      template: PHOTO_TRIO_PAGE_WIDTH_DEFAULT,
    },
    noPhoto: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/noPhoto-v1_1_1.json',
      template: NO_PHOTO_DEFAULT,
    },
    photoArch: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoArch-v1_1_1.json',
      template: PHOTO_ARCH_DEFAULT,
    },
    photoDuoLeft: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoDuoLeft-v1_1_1.json',
      template: PHOTO_DUO_LEFT_DEFAULT,
    },
    photoDuoRight: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoDuoRight-v1_1_1.json',
      template: PHOTO_DUO_RIGHT_DEFAULT,
    },
    photoMarquee: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoMarquee-v1_1_1.json',
      template: PHOTO_MARQUEE_DEFAULT,
    },
    photoBackground: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoBackground-v1_1_3.json',
      template: PHOTO_BACKGROUND_DEFAULT,
    },
    photoBackgroundMonogram: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/photoBackgroundMonogram-v1_0_1.json',
      template: PHOTO_BACKGROUND_MONOGRAM_DEFAULT,
    },
    videoBackground: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/videoBackground-v1_1_1.json',
      template: VIDEO_BACKGROUND_DEFAULT,
    },
    videoBackgroundMonogram: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/videoBackgroundMonogram-v1_0_0.json',
      template: VIDEO_BACKGROUND_MONOGRAM_DEFAULT,
    },
    videoArch: {
      schemaUrl: 'https://withjoy.com/assets/public/websiteHeaderSchemas/videoArch-v1_1_1.json',
      template: VIDEO_ARCH_DEFAULT,
    },
  },
};
